import { takeLatest, call, put } from "redux-saga/effects"
import { clearMultibase } from "../actions/multiAiBase"
import { logoutUser } from "../actions/userActions"
import { GET_AUDIT_DETAILS_REQUEST } from "../types"
import { CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage } from "../utils"
import { getAuditDetailsSuccess, getAuditDetailsFailed, getAuditDetailsReset } from "../actions/auditActions"
import { auditService } from "../services/auditService"

function* getAuditDetails(action) {
	try {
		const result = yield call(auditService?.getAuditDetails, action?.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getAuditDetailsSuccess(result?.data?.data))
		} else {
			yield put(getAuditDetailsFailed(result?.data?.message))
		}
	} catch (error) {
		if (error?.response?.status === 403) {
			clearLocalStorage()
			yield put(clearMultibase())
			yield put(logoutUser())
			return
		}
		yield put(getAuditDetailsFailed(Messages.SERVER_ERROR))
		yield put(getAuditDetailsReset())
	}
}

export default function* dashboardSaga() {
	yield takeLatest(GET_AUDIT_DETAILS_REQUEST, getAuditDetails)
}
